import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=6b115954&"
import script from "./detail.vue?vue&type=script&lang=js&"
export * from "./detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jonas/Projects/Risolto/operator-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b115954')) {
      api.createRecord('6b115954', component.options)
    } else {
      api.reload('6b115954', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=6b115954&", function () {
      api.rerender('6b115954', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/_payment_documents/detail.vue"
export default component.exports